import React, { useEffect, useState } from "react";
import api from "../../seller-apis/api";
import '../order.css';
import { useAlert } from "react-alert";
import { NavLink } from 'react-router-dom';
import { fetchOpportunityData } from '../../seller-apis/apidataField';
import PaginationNew from "../common/Pagination";
import servicesApi from '../../seller-apis/servicesApi';
import Popup from '../common/Popup';
import UpdtProPopup2 from '../common/UpdtProPopup2';
var globalFilterData = {
  pageNo: 1,
  size: 12,
  filters: {
    "status": "done"
  },
  sortFilter: {"createdAt":-1 },
};
function AllOpportunity() {
  const alert=useAlert();
  const [showModal, setShowModal] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [tickets, setTickets] = useState([]);
  // const [ticket, setTicket] = useState(null);
  // const [ticketForFilter, setTicketForFilter] = useState([]);
  const [descs, setDescs] = useState([]);
  const [showModalDescription, setShowModalDescription] = useState(false);
  var currentDate = new Date();

  // Get the date before 15 days
  var before15Days = new Date();
  before15Days.setDate(currentDate.getDate() - 30);

  // Format the dates as strings (optional)
  var currentDateStr = currentDate.toISOString().split("T")[0];
  var before15DaysStr = before15Days.toISOString().split("T")[0];
  const [sortdatefrom, setsortdatefrom] = useState(before15DaysStr);
  const [sortdateto, setsortdateto] = useState(currentDateStr);
  const [minValDate, setMinValDate] = useState("2023-08-01");
  const [orderId, setOrderId] = useState("");
  const [totalRcord, setTotalReord] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const statusCheck=['open','reopen','repene'];
  const [cbimg, setcbimg] = useState();
	const [selectedProductPopup, setselectedProductPopup] = useState();
	const [updtProVisibility, setupdtProVisibility] = useState(false);
	const [clickedUpdateNo, setclickedUpdateNo] = useState();
  const [updtPopuprel, setupdtPopuprel] = useState([]);
  const [otherSellerPrice, setotherSellerPrice] = useState();
  const [opportunityId, setOpportunityId] = useState(null);

  useEffect(() => {
    // let filterData = globalFilterData;

    // globalFilterData.filter["from-createdAt"] = sortdatefrom + "T00:00:00";
    // globalFilterData.filter["to-createdAt"] = sortdateto + "T23:59:59";
    globalFilterData = {
      pageNo: 1,
      size: 12,
      filters: {
        "status": "done"
      },
      sortFilter: {"createdAt":-1 },
    };
    api.Opportunity.fetchOpportunity(fetchOpportunityData(globalFilterData)).then(res => {
      // console.log("Opportunity res: ", res);
      setTotalReord(res.totalRecords);
      setTickets(res.data);
    });
  }, []);
  const getOpportunity = (filterData) => {
    api.Opportunity.fetchOpportunity(fetchOpportunityData(filterData)).then((review) => {
      setTotalReord(review.totalRecords);
      let data=review.data;
      setTickets(data);
    });
  };
  const dateFilter = (e) => {
    if(sortdatefrom === undefined || sortdateto === undefined || sortdateto === "" || sortdatefrom === "") { 
      alert.show("please select both date");
    }
    else{
    let filterData = globalFilterData;

    filterData.filter["from-createdAt"] = sortdatefrom + "T00:00:00";
    filterData.filter["to-createdAt"] = sortdateto + "T23:59:59";

    getOpportunity(filterData);
    }
  };

  function paginate(data) {
    // console.log(data);
    setCurrentPage(data.number);
    // let filterProduct = {
    //   pageNo: data.number,
    //   filter: { status: "draft" },
    // };
    let filter=globalFilterData;
    filter['pageNo']=data.number;
    getOpportunity(filter);
  }

  // For detail of product
  const detailnew = (url, price) => {
    let data =
    {
      "filter": { "urlKey": url }
    }
    servicesApi.getProductDetail(data).then((res) => {
      detail([res.data], price)

      setpopupVisibilityDetail("2");
    }).catch(err => console.log(err))

  }

  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      "description": undefined,
      "sdescription": undefined,
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [mediaPopupVis, setMediaPopupVis] = useState("block");
  const [detailPPrice, setdetailPPrice] = useState("");
  // Popup showing detail
  function detail(data, price) {
    setdetailPPrice(price)
    console.log(data)
    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }
  
  //Popup related functions
  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }

  // Check response of product added
	function callbackResponse(msg) {
		if (msg === "product added" || msg === "product updated") {
			setupdtProVisibility(false);
			alert.success("Product Added Successfully");
			if (opportunityId !== null) {
				api.Opportunity.deleteOpportunity(opportunityId).then(res => {
					// console.log("Opportunity res: ", res);
				}).catch((err) => console.log(err));
			}
      getOpportunity(globalFilterData);
		}
		else {
			setupdtProVisibility(false)
			alert.error("Product not added")
		}
	}

  function checkpopupvisibility(e) {
		if (e === false) {
			setupdtProVisibility(false)
		}
		else {
			setupdtProVisibility(true)
		}
	}

  function handleAddProduct (img, ticket) {
    setupdtPopuprel({
      "SKU": ticket.SKU,
      "taxClass": ticket.taxClass,
      "pkgs": ticket.pkg,
      "categories": ticket.categories
    });
    setcbimg(img);
		setselectedProductPopup(ticket.productName);
		setclickedUpdateNo(ticket.productId);
    setOpportunityId(ticket._id);
		setupdtProVisibility(true);
    setotherSellerPrice(ticket.onClick);
  }

  return (
    <div>
      {/* <div className="d-flex mb-3 justify-content-start">
        <div className="theme-shed1 p-2">
          <div className="m-auto mt-1">
            <span className="payment_dates">
              From: -{" "}
              <input
                type="date"
                min={minValDate}
                value={sortdatefrom}
                onChange={(e) => setsortdatefrom(e.target.value)}
              ></input>
            </span>
            <span className="mx-2 payment_dates">
              To: -{" "}
              <input
                type="date"
                min={minValDate}
                value={sortdateto}
                onChange={(e) => setsortdateto(e.target.value)}
              ></input>
            </span>
            <span>
              <button
                className="apply-btn px-3 py-1 ff_Pop fs-14"
                onClick={() => dateFilter()}
              >
                Apply
              </button>
            </span>
          </div>
        </div>
      </div> */}
      <div className="table-responsive">
      <table className="ord_table new-table-design" style={{ "width": "100%" }}>
        <thead>
          <tr>
          <th>
              Product Image
            </th>
            <th>
              Product Details
            </th>
            <th>
            Other Seller Price
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tickets.length > 0 && tickets.map((ticket, index) => {
            let baseImg;
            ticket.images.map((item) => {
              if (item.baseImage === true) {
                if (item.image.startsWith("products")) {
                  baseImg = item.image;
                }
                else {
                  let img = item.image.substr("41")
                  baseImg = img;
                }
              }
            })
            return (
              <tr>
                <td>
                  <div className='border-x'>
                    <img src={"https://s3.toolsvilla.com/" + baseImg} alt="img" className="px-2 product-i mx-1" />
                  </div>
                </td>
                <td className='fs-13 order_table_pname_cntn'>
                  <div className='border-x inline-initial'>
                    <a href='#popupDetail' onClick={() => detailnew(ticket.urlKey, ticket?.productId?.price)} className='prod-name'>{ticket.productName}</a>
                    <div className='order_table_sku'>SKU:- {ticket.SKU}</div>
                    <a href='#popupDetail' onClick={() => detailnew(ticket.urlKey, ticket?.productId?.price)} className='detail-but'>
                      <button className='px-1 order_table_btn_details'>View Details</button>
                    </a>
                  </div>
                </td>
                <td>
                <div className='border-x'>
                  {ticket.purchase_price?
                  <>
                   <div className='prod-price'><i className="fa fa-inr" aria-hidden="true"></i> <span id={`${ticket._id}price`}>{ticket.purchase_price}</span></div>
                 <div className='prod-gst'>(incl. {ticket?.productId?.taxClass}% GST)</div>
                   </>
               
                 :<></>
                  }
                  </div>
               
                </td>
                <td>
                  <div className='border-x'>
                    <button className='p-1 order_table_btn_details' onClick={() => handleAddProduct(baseImg, ticket)}>+ Add this product</button>
                  </div>
                </td>
              </tr>
            );
          })}
          {tickets.length == 0 ? (
            <tr>
              <td colspan="6" className="text-center">
                No data found
              </td>
            </tr>
          ) : (
            ""
          )}
        </tbody>
      </table>
      </div>
      <PaginationNew
        number={totalRcord}
        paginate={paginate}
        activ={currentPage}
        comp={"support"}
      />

      <div id="popupDetail" className="overlay" style={{ "display": isDetailPopupVis }}>
        <Popup
          from="newOrder"
          description={productDetail[0].description}
          sdescription={productDetail[0].shortDescription}
          descriptionNew={productDetail[0].descriptionNew}
          specificationNew={productDetail[0].specificationNew}
          name={productDetail[0].productName}
          price={detailPPrice}
          SKU={productDetail[0].SKU}
          popupVisibility={setpopupVisibilityDetail}
          images={productDetail[0].images}
          videos={productDetail[0].videos}
        />
      </div>

      {  updtProVisibility === true ?
          <UpdtProPopup2
            lead={clickedUpdateNo}
            productName={selectedProductPopup}
            Popupvisible="block"
            img={cbimg}
            detail={updtPopuprel}
            lowestPrice={otherSellerPrice}
            Popupvisibilityfun={checkpopupvisibility}
            from="chooseProduct"
            callbackResFun={callbackResponse}
          /> : <></>
			}
    </div>
  );
}

export default AllOpportunity;